(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ue-pro-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ue-pro-hero-slider')) {
    customElements.define(
      'ue-pro-hero-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
          this.status = this.querySelector('[data-slider-status]');
          this.currentIndex = 0;
          this.handleViewportResize = () => this.setViewportHeight();

          this.setViewportHeight();
          window.addEventListener('resize', this.handleViewportResize);

          if (this.slides.length === 0) return;

          this.querySelector('[data-slider-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
          this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));

          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.show(index));
            dot.addEventListener('keydown', (event) => this.handleDotKeydown(event, index));
          });

          this.addEventListener('shopify:block:select', (event) => {
            const selectedSlide = event.target.closest('[data-slider-slide]');
            const selectedIndex = this.slides.indexOf(selectedSlide);
            if (selectedIndex >= 0) this.show(selectedIndex);
          });

          this.dataset.ready = 'true';
          this.show(0, false);
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleViewportResize);
        }

        setViewportHeight() {
          if (window.matchMedia('(max-width: 749px)').matches) {
            this.style.removeProperty('--ue-pro-hero-slider-viewport-height');
            return;
          }

          const sectionTop = Math.max(0, this.getBoundingClientRect().top);
          const availableHeight = Math.max(0, window.innerHeight - sectionTop);
          this.style.setProperty('--ue-pro-hero-slider-viewport-height', `${availableHeight}px`);
        }

        show(nextIndex, announce = true) {
          const total = this.slides.length;
          this.currentIndex = (nextIndex + total) % total;

          this.slides.forEach((slide, index) => {
            const isCurrent = index === this.currentIndex;
            slide.hidden = !isCurrent;
            slide.setAttribute('aria-hidden', String(!isCurrent));
          });

          this.dots.forEach((dot, index) => {
            if (index === this.currentIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          if (announce && this.status) {
            this.status.textContent = `Slide ${this.currentIndex + 1} of ${total}`;
          }
        }

        handleDotKeydown(event, index) {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = index + 1;
          if (event.key === 'ArrowLeft') nextIndex = index - 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.dots.length - 1;
          if (nextIndex === null) return;

          event.preventDefault();
          nextIndex = (nextIndex + this.dots.length) % this.dots.length;
          this.show(nextIndex);
          this.dots[nextIndex].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
